module.exports = __webpack_public_path__ + "static/p-logo--eccube-0db06eeaea0d83d1ba86f86d41ae6756.png";